import React from 'react';
import { connect } from 'react-redux';
import PropTypes from "prop-types";
import { AjaxSpinner, Button, Components, InputInformation, InputList, Size, MessagePopupTypes, MessagePopupPositions, MessagePopupCore, MessagePopup } from 'dts-react-common';
import { withRouter } from "react-router-dom";
import { dispatchUpdateData } from "../misc/Shared";
import Webservice from '../App/Webservice';
import { ajaxStatusCore } from "../app/Webservice";
import Icon from "../misc/Icon";
import { dispatchDefaultState } from '../app/ReduxStore';
import moment from 'moment';


const propTypes = {
    searchCriteria: PropTypes.shape({

        lastName: PropTypes.string,
        firstName: PropTypes.string,
        middleName: PropTypes.string,
        ssnNumber: PropTypes.string,
        birthDate: PropTypes.string,
        gender: PropTypes.string,

    }),
};

const defaultProps = {

    searchLimit: false,
    searchResultsData: undefined,
    searchTotal: null,
};

const mapStateToProps = state => ({
    searchCriteria: state.search.searchCriteria,
});

class VeteransConfirmationPage extends React.Component {


    constructor(props) {
        super(props);

        ajaxStatusCore.registerChangedCallback((ajaxId, isAjaxing) => {


            if (ajaxId === 'searchRecord') {
                this.setState({ isAjaxing: isAjaxing });
            }
        });
        this.fullName = {
            searchFName: new InputInformation({
                field: 'firstName',
                label: 'First Name *',
                type: Components.TEXT_INPUT,
                size: Size.LARGE,
                onChange: this.inputInformationChanged,
            }),
            searchLName: new InputInformation({
                field: 'lastName',
                label: 'Last Name *',
                type: Components.TEXT_INPUT,
                size: Size.LARGE,
                onChange: this.inputInformationChanged,
            }),
            searchBirthDate: new InputInformation({
                field: 'birthDate',
                label: 'BirthDate *',
                type: Components.CALENDAR_INPUT,
                maxDate: moment(),
                minDate: moment("01-01-1000"),
                size: Size.LARGE,
                onChange: this.inputInformationChanged,
            }),
            searchAddress: new InputInformation({
                field: 'address',
                label: 'Address *',
                type: Components.TEXT_INPUT,
                size: Size.LARGE,
                onChange: this.inputInformationChanged,
            }),
            searchCity: new InputInformation({
                field: 'city',
                label: 'City *',
                type: Components.TEXT_INPUT,
                size: Size.LARGE,
                onChange: this.inputInformationChanged,
            }),
            searchState: new InputInformation({
                field: 'state',
                label: 'State *',
                type: Components.SELECT_INPUT,
                options: [
                    { label: "Alabama", value: "AL" },
                    { label: "Alaska", value: "AK" },
                    { label: "Arizona", value: "AZ" },
                    { label: "Arkansas", value: "AR" },
                    { label: "California", value: "CA" },
                    { label: "Colorado", value: "CO" },
                    { label: "Connecticut", value: "CT" },
                    { label: "Delaware", value: "DE" },
                    { label: "Florida", value: "FL" },
                    { label: "Georgia", value: "GA" },
                    { label: "Hawaii", value: "HI" },
                    { label: "Idaho", value: "ID" },
                    { label: "Illinois", value: "IL" },
                    { label: "Indiana", value: "IN" },
                    { label: "Iowa", value: "IA" },
                    { label: "Kansas", value: "KS" },
                    { label: "Kentucky", value: "KY" },
                    { label: "Louisiana", value: "LA" },
                    { label: "Maine", value: "ME" },
                    { label: "Maryland", value: "MD" },
                    { label: "Massachusetts", value: "MA" },
                    { label: "Michigan", value: "MI" },
                    { label: "Minnesota", value: "MN" },
                    { label: "Mississippi", value: "MS" },
                    { label: "Missouri", value: "MO" },
                    { label: "Montana", value: "MT" },
                    { label: "Nebraska", value: "NE" },
                    { label: "Nevada", value: "NV" },
                    { label: "New Hampshire", value: "NH" },
                    { label: "New Jersey", value: "NJ" },
                    { label: "New Mexico", value: "NM" },
                    { label: "New York", value: "NY" },
                    { label: "North Carolina", value: "NC" },
                    { label: "North Dakota", value: "ND" },
                    { label: "Ohio", value: "OH" },
                    { label: "Oklahoma", value: "OK" },
                    { label: "Oregon", value: "OR" },
                    { label: "Pennsylvania", value: "PA" },
                    { label: "Rhode Island", value: "RI" },
                    { label: "South Carolina", value: "SC" },
                    { label: "South Dakota", value: "SD" },
                    { label: "Tennessee", value: "TN" },
                    { label: "Texas", value: "TX" },
                    { label: "Utah", value: "UT" },
                    { label: "Vermont", value: "VT" },
                    { label: "Virginia", value: "VA" },
                    { label: "Washington", value: "WA" },
                    { label: "West Virginia", value: "WV" },
                    { label: "Wisconsin", value: "WI" },
                    { label: "Wyoming", value: "WY" },
                    // Also including territories and the District of Columbia for completeness if needed
                    { label: "American Samoa", value: "AS" },
                    { label: "District Of Columbia", value: "DC" },
                    { label: "Federated States Of Micronesia", value: "FM" },
                    { label: "Guam", value: "GU" },
                    { label: "Marshall Islands", value: "MH" },
                    { label: "Northern Mariana Islands", value: "MP" },
                    { label: "Palau", value: "PW" },
                    { label: "Puerto Rico", value: "PR" },
                    { label: "Virgin Islands", value: "VI" },
                ],
                size: Size.LARGE,
                onChange: this.inputInformationChanged,
            }),
            searchZipCode: new InputInformation({
                field: 'zipCode',
                label: 'Zip Code *',
                type: Components.TEXT_INPUT,
                size: Size.LARGE,
                onChange: this.inputInformationChanged,
            }),



        };

        this.vetNameField = [
            this.fullName.searchFName,
            this.fullName.searchLName,
            this.fullName.searchBirthDate,
            this.fullName.searchAddress,
            this.fullName.searchCity,
            this.fullName.searchState,
            this.fullName.searchZipCode,



        ];
    }

    componentDidMount() {

    }
    state = {
        isVeteran: undefined,
        redirect: null,
        firstName: "",
        lastName: "",
        birthDate: "",
        address: "",
        zipCode: "",
        city: "",
        state: "",
        message: undefined,
        reqfielderrormsg: undefined
    }
    inputInformationChanged(field, value) {

        dispatchUpdateData({ path: 'search.searchCriteria', field: field, value: value });
    }
    onSelectChange = inputValue => {


        this.setState({
            gender: inputValue ? inputValue.value : ""
        });

    };

    colourStyles = {
        control: (styles) => ({
            ...styles,
            boxShadow: 'none !important',
            borderRadius: '0px', margin: '-1px', fontSize: '12px', borderColor: 'transparent ', borderWidth: '0px',
            ':focus': {
                borderColor: 'transparent !important'
            }
        }),
        option: styles => ({
            ...styles, fontSize: '12px'
        }),
    };

    showPopupMessage(message, className = "success") {
        MessagePopupCore.addMessage({
            message: message,
            type: MessagePopupTypes.DIALOG,
            position: MessagePopupPositions.BOTTOM_CENTER,
            icon: Icon.iconInfo,
            className: className,
        });
    }

    clear() {
        this.setState({
            isVeteran: undefined,
            message: undefined,
            first_name: "",
            reqfielderrormsg: ""
        });

        dispatchDefaultState(['search.searchCriteria']);
    }

    submit() {
        console.log(this.state);
        const {
            firstName,
            lastName,
            birthDate,
            address,
            zipCode,
            city,
            state,


        } = this.props.searchCriteria;
        if (firstName == null || firstName == undefined || firstName == "") {
            this.setState({
                reqfielderrormsg: 'First Name is required'

            });
            return;
        }
        else if (lastName == null || lastName == undefined || lastName == "") {
            this.setState({
                reqfielderrormsg: 'Last Name is required'

            });
            return;
        }
        else if (city == null || city == undefined || city == "") {
            this.setState({
                reqfielderrormsg: 'City is required'

            });
            return;
        }
        else if (address == null || address == undefined || address == "") {
            this.setState({
                reqfielderrormsg: 'Address is required'

            });
            return;
        }
        else if (state == null || state == undefined || state == "") {
            this.setState({
                reqfielderrormsg: 'State is required'

            });
            return;
        }

        else if (zipCode == null || zipCode == undefined || zipCode == "") {
            this.setState({
                reqfielderrormsg: 'Zip Code is required'

            });
            return;
        }
        else if (birthDate == null || birthDate == undefined || birthDate == "") {
            this.setState({
                reqfielderrormsg: 'Birth Date is required'

            });
            return;
        }
        else {
            this.setState({
                reqfielderrormsg: ''
            })
        }
        this.setState({ isAjaxing: true });
        const dob = new Date(birthDate);
        const month = dob.getMonth() < 9 ? "0" + parseInt(dob.getMonth() + 1) : parseInt(dob.getMonth() + 1);
        const date = dob.getDate() <= 9 ? "0" + dob.getDate() : dob.getDate();


        let details = {
            "firstName": firstName,
            "lastName": lastName,
            "birthDate": dob.getFullYear() + "-" + month + "-" + date,
            "address": address,
            "zipCode": zipCode,
            "city": city,
            "state": state,
            "country": "USA"
        }
        console.log(details);

        Webservice.veteranStatus.statusRequest(details)

            .catch(error => {

                this.setState({ isAjaxing: false, message: "Timeout Error,Please try again", isVeteran: 'not-confirmed' });

            })
            .then(data => {
                if (!data.errors) {
                    var today = new Date();
                    const dateTime = "\n " + "Verified at" + " " + (today.getMonth() + 1) + '-' + today.getDate() + '-' + today.getFullYear() + ' on   (Time:' + today.getHours() +
                        ':' + today.getMinutes() + ':' + today.getSeconds() + ')';

                    let iscssapplicable = data.veteran_status == "confirmed" ? "" : "not";
                    let isVeteran = data.veteran_status == "confirmed" ? "a Confirmed Veteran" : "not a Confirmed Veteran";

                    let msg = this.props.searchCriteria.firstName + " " + this.props.searchCriteria.lastName + " " + " is " + isVeteran;


                    this.setState({
                        message: {
                            vtmsg: msg,
                            vtverified: "( " + dateTime + ")",
                        }, isVeteran: iscssapplicable == "" ? 'message-display-true' : 'not-confirmed'
                    });


                }
                else {
                    this.setState({ isAjaxing: false });


                    let detail = data.errors[0].detail;


                    detail = detail.replace('",', '').replace('"', '').replace("firstName", "First Name").
                        replace("lastName", "Last Name")
                    // .replace("address", "Address")
                    // .replace("birthDate", "Birth Date")
                    // .replace("city", "City");
                    this.setState({ message: detail, isVeteran: 'not-confirmed' });

                }

                this.setState({ isAjaxing: false });
            })
    }
    print() {
        window.print();
    }

    render() {

        return (
            <div>
                <h1 className="title-page">Welcome to Veteran Verification System</h1>
                <div className="searchPage-container">
                    <div className="print-container "><h2 className="text-left">Please Enter Veteran Details </h2>
                        <Button label="Print" onClick={() => { this.print(); }} /></div>
                    <div className="search-form-container">
                        <div className="search-form">

                            <InputList inputs={this.vetNameField} data={this.props.searchCriteria} />

                        </div>
                    </div>
                </div>
                <div className="page-actions">
                    <Button label="Verify" onClick={() => { this.submit(); }} />
                    <Button label="Clear" onClick={() => { this.clear(); }} />

                </div>
                {
                    this.state.reqfielderrormsg && this.state.reqfielderrormsg != "" &&
                    <>
                        <div className={`message-display font-size`}>
                            {
                                this.state.reqfielderrormsg
                            }
                        </div>
                    </>
                }


                {
                    <>
                        {
                            this.state.message &&
                            <>
                                <div className={`message-display font-size ${this.state.isVeteran}`}>


                                    {this.state.message.vtmsg ? this.state.message.vtmsg : this.state.message}
                                </div>
                                <div className='vt-verified'>
                                    {
                                        this.state.message.vtverified
                                    }
                                </div>
                            </>
                        }

                        <React.Fragment>
                            {this.state.isAjaxing && <div className='message-display'> <AjaxSpinner size={40} /> </div>}
                        </React.Fragment>
                    </>

                }
                {
                    this.state.message == undefined && this.state.isVeteran == undefined &&
                    <div className="disclaimer">
                        The Veteran Verification system provides a response whether a given person is <div className='confirmed'> "confirmed"</div> or<div className='not-confirmed'> "not confirmed" </div>as a <a href='https://www.ecfr.gov/current/title-38' target='_blank'>Title 38 Veteran.</a><br /><br />

                        A Veteran is a person who served in the active military, naval, air, or space service, and who was discharged or released under conditions other than dishonorable. Active Duty service history in the Reserves and National Guard is considered active military.<br /><br />

                        A person may have served without being entitled to the VA benefits of a Title 38 Veteran. If so, this system will return a <div className='not-confirmed'> "not confirmed" </div>  status. Reasons for this can include dishonorable character of service or insufficient length of Active Duty, dates of service, or disability details
                    </div>
                }



            </div>
        );
    }
}

VeteransConfirmationPage.propTypes = propTypes;
VeteransConfirmationPage.defaultProps = defaultProps;


export default withRouter(connect(mapStateToProps)(VeteransConfirmationPage));